import { render, staticRenderFns } from "./childrenAbcScale.vue?vue&type=template&id=b09f962c&scoped=true"
import script from "./childrenAbcScale.vue?vue&type=script&lang=js"
export * from "./childrenAbcScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09f962c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b09f962c')) {
      api.createRecord('b09f962c', component.options)
    } else {
      api.reload('b09f962c', component.options)
    }
    module.hot.accept("./childrenAbcScale.vue?vue&type=template&id=b09f962c&scoped=true", function () {
      api.rerender('b09f962c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/childrenAbcScale/abc/childrenAbcScale.vue"
export default component.exports